<div class="container-fluid">
    <div class="row justify-content-center">

        <div class="col-12">
            <div class="card my-5 text-center custom-shadow">
                <div class="card-header color-secundario-fondo text-white custom-shadow custom-card-header py-3">
                    <h4>{{titulo}}</h4>
                </div>

                <div class="card-body p-0">

                    <div class="container-fluid p-0 my-3">
                        <form (ngSubmit)="onSubmit()" [formGroup]="formulario">
                            <div class="row justify-content-center">
                                <div class="col-sm-12 col-md-10">
                                    <div class="form-floating my-3">
                                        <select
                                            [class]="(getCerDependencia()?.valid ? 'form-select is-valid':'form-select is-invalid')"
                                            aria-label="Seleccionar dependencia" formControlName="cerDependencia"
                                            id="cerDependencia" (change)="onChangeCerDependencia()" required>
                                            <option value="" disabled selected>Seleccione una opción</option>
                                            <option *ngFor="let c of dependencias" [value]="c.cerd_codigo">
                                                {{c.cerd_nombre}}
                                            </option>
                                        </select>
                                        <label for="cerDependencia"><i
                                                class="bi bi-menu-button-wide-fill mx-3"></i>Dependencia</label>
                                        <div *ngIf="getCerDependencia()?.hasError('required')" class="invalid-feedback">
                                            La dependencia es requerida
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="getCerDependencia()?.valid && litCodigo != 16" class="row justify-content-center">
                                <div class="col-sm-12 col-md-5">
                                    <div class="form-floating my-3">
                                        <select
                                            [class]="(getPeriodoInicio()?.valid ? 'form-select is-valid':'form-select is-invalid')"
                                            aria-label="Seleccionar periodo inicio" formControlName="periodoInicio"
                                            id="periodoInicio" (change)="onChangePerInicio()" required>
                                            <option value="" disabled selected>Seleccione una opción</option>
                                            <option *ngFor="let p of periodos" [value]="p.per_codigo">{{ p.per_anno + '
                                                - ' + p.per_periodo }}
                                            </option>
                                        </select>
                                        <label for="periodoInicio"><i
                                                class="bi bi-menu-button-wide-fill mx-3"></i>Periodo Inicio</label>
                                        <div *ngIf="getPeriodoInicio()?.hasError('requiredPeriodo')" class="invalid-feedback">
                                            El periodo de inicio es requerido
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-5">
                                    <div class="form-floating my-3">
                                        <select
                                            [class]="(getPeriodoFin()?.valid ? 'form-select is-valid':'form-select is-invalid')"
                                            aria-label="Seleccionar Periodo Fin" formControlName="periodoFin"
                                            id="periodoFin" required>
                                            <option value="" disabled selected>Seleccione una opción</option>
                                            <option *ngFor="let p of periodosFin" [value]="p.per_codigo">{{ p.per_anno +
                                                ' - ' + p.per_periodo }}
                                            </option>
                                        </select>
                                        <label for="periodoFin"><i class="bi bi-menu-button-wide-fill mx-3"></i>Periodo
                                            Fin</label>
                                        <div *ngIf="getPeriodoFin()?.hasError('requiredPeriodo')" class="invalid-feedback">
                                            El periodo de fin es requerido
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button *ngIf="formulario.valid" type="submit" id="button-vista-previa"
                                    class="btn btn-primary color-primario-fondo shadow">Ver Vista Previa</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="card-body p-0">

                    <div class="container-fluid p-0 text-center mb-5 color-primario-letra">

                        <div class="row justify-content-center">

                            <div class="col" *ngIf="(tipoCertificados.length > 0)">
                                <div class="table-responsive">

                                    <table class="table table-borderless my-3">

                                        <thead class="color-alternativo-fondo">
                                            <tr>
                                                <th class="py-3" *ngFor="let e of encabezadosDeseleccionados">{{e}}</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr *ngIf="tipoCertificados.length > 0">
                                                <td class="py-3" colspan="2">
                                                    <button class="btn btn-primary color-primario-fondo shadow"
                                                        style="width: 80%;"
                                                        (click)="onClickSeleccionarTodos()">Seleccionar Todos
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr *ngFor="let tc of tipoCertificados; index as i">
                                                <td class="py-3">{{tc.cert_nombre}}</td>
                                                <td class="py-3">
                                                    <button class="btn btn-primary color-primario-fondo shadow"
                                                        (click)="onClickSeleccionar(tc,i)">Seleccionar
                                                    </button>
                                                </td>
                                            </tr>

                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <div class="col" *ngIf="(tcSeleccionados.length > 0)">
                                <div class="table-responsive">

                                    <table class="table table-borderless my-3">

                                        <thead class="color-alternativo-fondo">
                                            <tr>
                                                <th class="py-3" *ngFor="let e of encabezadosSeleccionados">{{e}}</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr *ngFor="let tc of tcSeleccionados; index as i">
                                                <td class="py-3">{{tc.cert_nombre}}</td>
                                                <td class="py-3">
                                                    <button class="btn btn-primary color-secundario-fondo shadow"
                                                        (click)="onClickDeseleccionar(tc,i)"> Descartar
                                                    </button>
                                                </td>
                                            </tr>

                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #popupVistaPrevia let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Vista Previa</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <button *ngIf="certificadoInfo" (click)="imprimirCertificado()" 
            class="btn btn-primary color-primario-fondo shadow mb-3">Imprimir Certificado</button>
        <ngx-extended-pdf-viewer [base64Src]="certificadoInfo.documentoVistaPrevia" [useBrowserLocale]="true" [enablePrint]="false"
            [showOpenFileButton]="false" [showDownloadButton]="false" [showPropertiesButton]="false"
            [showBookmarkButton]="false" [showPropertiesButton]="false" [showSecondaryToolbarButton]="false"
            height="71vh" [zoom]="'100%'" backgroundColor="#e8e8ef"></ngx-extended-pdf-viewer>
    </div>
</ng-template>